import { areFieldsPristine, areFieldsTouched } from "../FieldValidators";
import { isEmailValid } from "../../../customer/utils";

/**
 * Validates the user inputs of the payment form
 *
 * @param {object} fields
 */
export const validatePaymentForm = fields => {
  const fieldErrors = {};
  const hasChanged = !areFieldsPristine(fields);
  if (!hasChanged) {
    return {
      fieldErrors,
      isFormInvalid: true
    };
  }
  const {
    paypalAccount,
    profile
  } = fields;
  if (!paypalAccount.pristine && !paypalAccount.value) {
    fieldErrors.paypalAccount = "Please enter your paypal address";
  } else if (!paypalAccount.pristine && !isEmailValid(paypalAccount.value)) {
    fieldErrors.paypalAccount = "Invalid paypal account";
  } else if (paypalAccount.pristine && (profile === null || profile === void 0 ? void 0 : profile.paypalAccount) === (paypalAccount === null || paypalAccount === void 0 ? void 0 : paypalAccount.value) && (profile === null || profile === void 0 ? void 0 : profile.email) !== paypalAccount.value && paypalAccount.verificationState === 1) {
    fieldErrors.paypalAccount = "Please update your PayPal address ";
  }
  const isFormInvalid = Object.keys(fieldErrors).length > 0 || !areFieldsTouched(fields) || (profile === null || profile === void 0 ? void 0 : profile.paypalAccount) === (paypalAccount === null || paypalAccount === void 0 ? void 0 : paypalAccount.value);
  return {
    fieldErrors,
    isFormInvalid
  };
};